import Box from "@mui/material/Box";
import ServerAlerts from "./components/ServerAlerts/ServerAlerts";
import IdealCustomerAlerts from "./components/IdealCustomerAlerts/IdealCustomerAlerts";
import AspenAlerts from "./components/AspenAlerts/AspenAlerts";
import AspenAnonymousUserAlerts from "./components/AspenAnonymousUserAlerts";

const Alerts = (props: any) => {
  const { SetAspenAlerts } = props;
  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      <Box sx={{ width: "auto", display: "table" }}>
        <ServerAlerts />
        <IdealCustomerAlerts />
        <AspenAlerts SetAspenAlerts={SetAspenAlerts} />
        <AspenAnonymousUserAlerts />
      </Box>
    </Box>
  );
};

export default Alerts;
